import { render, staticRenderFns } from "./remove-group-user-modal.vue?vue&type=template&id=74e7d2a3&"
import script from "./remove-group-user-modal.vue?vue&type=script&lang=js&"
export * from "./remove-group-user-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports